import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "./common/Select";
import ClientSearch from "./common/ClientSearch";

function AllCaseloadClientSearch(props) {
  const [selectedState, setSelectedState] = useState("");
  const [client, setClient] = useState(null);
  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    if (
      safyInfo?.user &&
      safyInfo.user.safyInfo.BusinessUnitIdName !== "ccplive"
    )
      setSelectedState(safyInfo.user.safyInfo.BusinessUnitIdName);
  }, [safyInfo]);

  useEffect(() => {
    if (client !== null) {
      console.log("Selected Client", client);
      if (client?.programs) {
        console.log("Navigating to Client");
        navigate(`/client/${client.contactid}`);
      } else {
        console.log("Navigating to Contact");
        navigate(`/nonclient/${client.contactid}`);
      }
    }
  }, [client]);

  return (
    <div>
      {safyInfo.user.safyInfo.BusinessUnitIdName === "ccplive" ||
      safyInfo.user.modules.includes("Admin") ? (
        <div className="row mt-4">
          <div className="col-4">
            <Select
              name="clientSearchState"
              label="Select State"
              value={selectedState}
              options={[
                { _id: "SAFY of Alabama", name: "Alabama" },
                { _id: "SAFY of Colorado", name: "Colorado" },
                { _id: "SAFY of Indiana", name: "Indiana" },
                { _id: "SAFY of Kentucky", name: "Kentucky" },
                { _id: "SAFY of Nevada", name: "Nevada" },
                { _id: "SAFY of Ohio", name: "Ohio" },
                { _id: "SAFY of South Carolina", name: "South Carolina" },
              ]}
              onChange={(e) => setSelectedState(e.currentTarget.value)}
            />
          </div>
        </div>
      ) : null}
      {selectedState !== "" && (
        <>
          <div className="h4 my-4">Contact Search</div>
          <ClientSearch
            state={selectedState}
            show={selectedState !== ""}
            setShow={() => setSelectedState("")}
            setClient={(e) => setClient(e)}
          />
        </>
      )}
    </div>
  );
}

export default AllCaseloadClientSearch;
